export default "__VITE_ASSET__BP0C52Zu__"